import * as React from "react";
import { forwardRef } from "react";
const SvgTiktokGlyph = ({
  title,
  titleId,
  ...props
}, ref) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, viewBox: "0 0 24 24", fill: "currentColor", "aria-hidden": "true", ref, "aria-labelledby": titleId, ...props }, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", { d: "M19.59 6.69a4.83 4.83 0 0 1-3.77-4.25V2h-3.45v13.67a2.89 2.89 0 0 1-5.2 1.74 2.89 2.89 0 0 1 2.31-4.64 2.93 2.93 0 0 1 .88.13V9.4a6.84 6.84 0 0 0-1-.05A6.33 6.33 0 0 0 5.83 20.6a6.34 6.34 0 0 0 10.86-4.43V9.4a8.18 8.18 0 0 0 4.77 1.52V7.46a4.85 4.85 0 0 1-1.87-.77Z" }));
const ForwardRef = forwardRef(SvgTiktokGlyph);
export default ForwardRef;
